'use strict';

var holidaysModule = angular.module('t2g.holidays', [
  'gettext',
  'ui.router',
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

var today = new Date();

module.exports = holidaysModule;

holidaysModule.config(function($stateProvider) {
  $stateProvider.state('private.main.holidays', {
    url: '/holidays',
    title: 'Holidays',
    templateUrl: '/app/modules/holidays/HolidaysView.html?v=4.5.6',
    controller: 'holidaysCtrl',
    resolve: {
      officeResponse: function(OfficeDA) {
        return OfficeDA.get();
      },
      countryConfigResolve: function($q, CountryConfig) {
        return CountryConfig.get();
      },
    },
  });
});

holidaysModule.controller('holidaysCtrl', function(
  $scope,
  countryConfigResolve,
  gettextCatalog,
  Notification,
  OfficeModel,
  officeResponse,
  DatepickerSettings,
) {
  $scope.office = officeResponse;
  $scope.countryConfig = countryConfigResolve;
  $scope.holidays = {};
  $scope.currentYear = today.getFullYear().toString();
  $scope.years = ['2017', '2018'];
  $scope.dtpOptions = DatepickerSettings.default;
  $scope.dtpOptions.maxMode = 'month';
  $scope.newHoliday = {
    name: '',
    date: new Date($scope.currentYear, 0, 1),
  };

  /**
   * set checkbox states
   */
  angular.forEach($scope.office.openingHours.special, function(value, key) {
    $scope.holidays[key] = true;
  });

  var initHolidays = function() {
    angular.forEach($scope.years, function(year) {
      $scope.mergeHolidays(year);
    });
  };

  /**
   * active are deactive holiday opening hours overwrite
   * @param holidayKey
   */
  $scope.changeState = function(holidayKey) {
    if ($scope.holidays[holidayKey]) {
      $scope.office.openingHours.special[holidayKey] = {
        open: true,
        times: [
          {
            start: 540,
            end: 720,
          },
        ],
      };
    } else {
      delete $scope.office.openingHours.special[holidayKey];
    }
  };

  /**
   * add a second column to enable two time slots per day ...
   * @param holidayKey
   */
  $scope.addSecondOpeningTime = function(holidayKey) {
    if ($scope.office.openingHours.special[holidayKey].times.length === 1) {
      // get closing hour of first opening time
      var firstClosingTime = $scope.office.openingHours.special[holidayKey].times[0].end;

      $scope.office.openingHours.special[holidayKey].times.push({
        start: firstClosingTime + 60 > 1440 ? 1440 : firstClosingTime + 60,
        end: firstClosingTime + 240 > 1440 ? 1440 : firstClosingTime + 240,
      });
    }
  };

  /**
   * ... end make it removeable
   * @param holidayKey
   */
  $scope.removeSecondOpeningTime = function(holidayKey) {
    if ($scope.office.openingHours.special[holidayKey].times.length === 2) {
      $scope.office.openingHours.special[holidayKey].times.splice(1, 1);
    }
  };

  /**
   * generate holidaykey
   * @param date
   * @returns {*}
   */
  $scope.getHolidayKey = function(date) {
    date = new Date(date);
    return date.getDayKey();
  };

  $scope.mergeHolidays = function(year) {
    angular.forEach($scope.office.openingHours.special, function(holiday, key) {
      if (holiday.custom && key.substring(0, 4) === year) {
        var date = new Date(key);

        $scope.countryConfig.holidays[year][key.substring(5, 10)] = {
          date: date,
          custom: holiday.custom,
          key: date.getDayKey(),
          name: holiday.name,
          public: false,
        };
      }
    });
  };

  $scope.addNewHoliday = function() {
    if ($scope.newHoliday.name && angular.isDate($scope.newHoliday.date)) {
      var holidayKey = $scope.newHoliday.date.getDayKey();

      $scope.office.openingHours.special[holidayKey] = {
        name: $scope.newHoliday.name,
        open: true,
        custom: true,
        date: $scope.newHoliday.date,
        times: [],
      };

      $scope.save();

      $scope.newHoliday = {
        name: '',
        date: new Date($scope.currentYear, 0, 1),
      };

      $scope.mergeHolidays($scope.currentYear);
    }
  };

  $scope.delete = function(dayKey) {
    var customHoliday = $scope.office.openingHours.special[dayKey];
    var shortDateKey = dayKey.substring(5);

    if (customHoliday && customHoliday.custom) {
      delete $scope.office.openingHours.special[dayKey];
      delete $scope.countryConfig.holidays[$scope.currentYear][shortDateKey];

      $scope.save(function() {
        $scope.mergeHolidays($scope.currentYear);
        Notification.addSuccessMessage(gettextCatalog.getString('Holiday removed'));
      });
    }
  };

  /**
   * save to rest webservice
   */
  $scope.save = function(cb) {
    OfficeModel.update($scope.office, function(error) {
      if (error) {
        Notification.addErrorMessage({ text: error });
      } else {
        if (cb) {
          cb();
        }

        Notification.addSuccessMessage(gettextCatalog.getString('Holiday saved'));
      }
    });
  };

  $scope.yearChanged = function() {
    $scope.newHoliday.date = new Date($scope.currentYear, 0, 1);
  };

  initHolidays();
});



// WEBPACK FOOTER //
// ./src/app/modules/holidays/holidaysModule.js